import type { SVGProps } from 'react';

const SvgWebhook = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20.46 13.98c-.53-.93-1.4-1.59-2.43-1.86a4.1 4.1 0 0 0-2.11 0l-3.06-5.26a1 1 0 0 0-1.37-.36c-.48.28-.64.89-.36 1.37l3.5 6.01c.28.48.89.64 1.36.36.46-.27 1-.34 1.52-.2s.95.47 1.21.93c.27.46.34 1 .2 1.52s-.47.95-.93 1.21c-.58.33-1.28.36-1.88.06-.5-.24-1.09-.04-1.34.46-.24.5-.04 1.09.46 1.34a3.98 3.98 0 0 0 3.76-.13c.93-.53 1.59-1.4 1.86-2.43.28-1.03.13-2.11-.4-3.04z"
    />
    <path
      fill="currentcolor"
      d="M17.98 15.97c0-.55-.45-1-1-1l-6.96.02c-.55 0-1 .45-1 1 0 1.1-.9 2-2 2s-2-.9-2-2c0-.67.33-1.29.88-1.66.46-.31.58-.93.27-1.39a1 1 0 0 0-1.39-.27c-1.1.75-1.76 1.99-1.76 3.32a3.999 3.999 0 0 0 7.87 1l6.09-.02c.55 0 1-.45 1-1"
    />
    <path
      fill="currentcolor"
      d="M9.18 10.22 6.15 15.5a.996.996 0 0 0 .87 1.49c.35 0 .68-.18.87-.5l3.46-6.04a.996.996 0 0 0-.37-1.36c-.46-.27-.79-.7-.93-1.21-.14-.52-.07-1.05.2-1.52.27-.46.7-.79 1.21-.93.52-.14 1.06-.07 1.52.2.58.33.95.93 1 1.6.04.55.5.97 1.07.93.55-.04.97-.52.93-1.07a4.01 4.01 0 0 0-1.99-3.19c-.92-.53-2-.68-3.04-.4-1.03.28-1.89.94-2.43 1.86-.53.93-.68 2-.4 3.04.19.7.55 1.33 1.06 1.82"
    />
  </svg>
);
export default SvgWebhook;
